<template>
  <div>
    <div v-if="blogs.length > 0">
      <a href="javascript:void(0)" @click.prevent="blogRoute(blogs[0], $event)">
        <figure class="relative cursor-pointer filter brightness-95 hover:brightness-100">
          <a href="javascript:void(0)">
            <img class="rounded-tl-lg rounded-br-lg h-52 md:h-72 w-full object-cover" :src="blogs[0].imageAddress" :alt="blogs[0].title" />
          </a>
          <figcaption class="absolute px-4 text-lg text-white bottom-6">
            <p class="line-clamp-2"><span class="bg-red-700 rounded-sm py-0 px-1 text-sm">جدید</span> {{ blogs[0].title }}</p>
          </figcaption>
        </figure>
      </a>
    </div>
    <div>
      <a href="javascript:void(0)" @click.prevent="blogRoute(item, $event)" v-for="item in blogs.slice(1, 5)" :key="item.id" class="py-2 grid grid-cols-2 items-center border-b border-gray-200 hover:bg-gray-100 dark:border-gray-700 dark:hover:bg-dim-700 group px-2">
        <div class="overflow-hidden h-28 xs:h-40 rounded-tl-lg rounded-br-lg">
          <img class="group-hover:scale-110 transition duration-300 dark:border-gray-700 h-full w-full object-cover" :src="item.imageAddress" :alt="item.title" />
        </div>
        <div class="flex flex-col justify-between px-4 py-2 leading-normal">
          <h1 class="mb-1 font-medium text-gray-700 dark:text-gray-400 line-clamp-3 text-sm sm:text-base">{{ item.title }}</h1>
          <span class="mr-auto text-gray-400 @text-overline-m mb-5">{{ item.createdDateLocal }}</span>
        </div>
      </a>
    </div>
    <div>
      <a href="javascript:void(0)" @click="setDynamicLink(item.link)" v-for="item in sliders" :key="item.id">
        <figure class="relative cursor-pointer filter brightness-95 hover:brightness-100">
          <a href="javascript:void(0)">
            <img class="rounded-tl-lg rounded-br-lg md:h-36 w-full object-cover" :src="item.backgroundImageAddress + '/' + item.imageName" alt="image description" />
          </a>
          <figcaption class="absolute px-4 text-lg text-white bottom-6">
            <p>{{ item.title }}</p>
          </figcaption>
        </figure>
      </a>
    </div>
    <div>
      <a href="javascript:void(0)" @click.prevent="blogRoute(item, $event)" v-for="item in blogs.slice(5, 10)" :key="item.id" class="py-2 grid grid-cols-2 items-center border-b border-gray-200 hover:bg-gray-100 dark:border-gray-700 dark:hover:bg-dim-700 group px-2">
        <div class="overflow-hidden h-28 xs:h-40 rounded-tl-lg rounded-br-lg">
          <img class="group-hover:scale-110 transition duration-300 dark:border-gray-700 h-full w-full object-cover" :src="item.imageAddress" :alt="item.title" />
        </div>
        <div class="flex flex-col justify-between px-4 py-2 leading-normal">
          <h1 class="mb-1 font-medium text-gray-700 dark:text-gray-400 line-clamp-3 text-sm sm:text-base">{{ item.title }}</h1>
          <span class="mr-auto text-gray-400 @text-overline-m mb-5">{{ item.createdDateLocal }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import alert from "@/plugins/AlertMessages.js";
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      alert,
    };
  },
  computed: {
    ...mapGetters({
      sliders: "dashboardX/sliders",
      blogs: "dashboardX/blogs",
    }),
  },
  watch: {},
  methods: {
    setDynamicLink(data) {
      window.open(data, "_blank");
    },
    blogPage(event) {
      let language = localStorage.getItem("languageId");
      if (event.ctrlKey == true) {
        if (language == 1) {
          const routeData = this.$router.resolve({ name: "FarsiBlogs" });
          window.open(routeData.href, "_blank").focus();
        } else if (language == 2) {
          const routeData = this.$router.resolve({ name: "ArabicBlogs" });
          window.open(routeData.href, "_blank").focus();
        }
      } else {
        if (language == 1) {
          this.$router.push({ name: "FarsiBlogs" });
        } else if (language == 2) {
          this.$router.push({ name: "ArabicBlogs" });
        }
      }
    },
    blogRoute(item, event) {
      let language = localStorage.getItem("languageId");
      const routeName = item.title.split(" ").join("-");
      if (event.ctrlKey == true) {
        if (language == 1) {
          const routeData = this.$router.resolve({
            name: "FarsiBlog",
            params: { id: item.id, title: routeName },
          });
          window.open(routeData.href, "_blank").focus();
        } else if (language == 2) {
          const routeData = this.$router.resolve({
            name: "ArabicBlog",
            params: { id: item.id, title: routeName },
          });
          window.open(routeData.href, "_blank").focus();
        }
      } else {
        if (language == 1) {
          this.$router.push({
            name: "FarsiBlog",
            params: { id: item.id, title: routeName },
          });
        } else if (language == 2) {
          this.$router.push({
            name: "ArabicBlog",
            params: { id: item.id, title: routeName },
          });
        }
      }
    },
    reloadData() {
      let payload = "pageSize=10";
      let language = localStorage.getItem("languageId");
      if (language) {
        payload += "&languageId=" + Number(localStorage.getItem("languageId"));
      }
      this.$store.dispatch("dashboardX/getSliders", payload);
      this.$store.dispatch("dashboardX/getBlogs", payload);
    },
  },
  metaInfo: {
    title: "صفحه اصلی",
  },
  beforeCreate() {
    const routePath = this.$route.path;
    const firstThreeLetters = routePath.slice(0, 3);
    if (firstThreeLetters === "/fa") {
      localStorage.setItem("languageId", 1);
    } else if (firstThreeLetters === "/ar") {
      localStorage.setItem("languageId", 2);
    }
  },
  mounted() {
    let payload = "pageSize=10";
    let language = localStorage.getItem("languageId");
    if (language) {
      payload += "&languageId=" + Number(localStorage.getItem("languageId"));
    }
    this.$store.dispatch("dashboardX/getSliders", payload);
    this.$store.dispatch("dashboardX/getBlogs", payload);
  },
};
</script>
